// Real Student Data from St Patrick's College
// This data was extracted from the official Student List files
// Total: 343 students across 14 classes

import { getStudentsForClass as getRealStudents } from './realStudents';

// Re-export the real student data function
export const getStudentsForClass = (classTitle) => {
  return getRealStudents(classTitle);
};
